import api from '../../../api/instance';
import { BulkAction } from '../models/bulk-action.model';
import { PrivateURLConstants } from '@constants/private-url.constant';
const nameSpace = PrivateURLConstants.BULK_ACTIONS;

const create = (data: BulkAction) => {
  return api
    .post(nameSpace, data)
    .then((res) => new BulkAction().deserialize(res))
    .catch((e) => Promise.reject(e));
};

const ping = (id: number) => {
  return api
    .get(nameSpace + `/${id}`)
    .then((res) => new BulkAction().deserialize(res))
    .catch((e) => Promise.reject(e));
};

const BulkActionService = {
  create,
  ping,
};

export default BulkActionService;
